import { RefObject } from 'react'

export const addAttributeToEmptyField = (newAttr: HTMLElement, inputRef: RefObject<HTMLElement>) => {
  inputRef.current.insertBefore(newAttr, inputRef.current.childNodes[0])
}
